// src/services/OperationTypesService.js

import axios from "axios";
import { BACKEND_URL } from "../utils/envConfig";

const API_URL = `${BACKEND_URL}/operation-types`;

export const getAll = async () => {
  // Use axios directly instead of apiClient to avoid automatic organizationId injection
  // Operation types are reference data stored in base table, common for all organizations
  const response = await axios.get(API_URL);
  return response.data;
};

export default {
  getAll
}